import React, { useState, FC } from 'react';
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms/types';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import IPhoneInputViewModel from '../../models/phoneInputView.model';
import './styles.scss';
import { useTranslation } from 'react-i18next';
import useFirstUserAction from '../../hooks/useFirstUserActionState';

const TelephoneField: FC<ValueFieldProps<IPhoneInputViewModel>> = (props) => {
  const { field, tracker } = props;
  const [value, setValue] = useState(props.value);
  const hasAnyError = !!props.errors?.length;
  const { t } = useTranslation();
  const FieldValidationErrors = props.fieldValidationErrorsComponent;
  const placeholder = field?.model?.placeholderText;
  const triggerFirstInteractionGTMEvent = useFirstUserAction();

  const onFocus = (): void => {
    tracker.onFocusField(field, value);
  };

  const onBlur = (): void => {
    tracker.onBlurField(field, value);
  };

  const onChange = (value: string): void => {
    setValue(value);
    props.onChange(field?.valueField?.name, `+${value}`, props?.isValid, []);
    triggerFirstInteractionGTMEvent();
  };

  return (
    <div
      className={`sitecore-jss-form__control sitecore-jss-form__control--text-box ${
        hasAnyError ? 'sitecore-jss-form__control--has-error' : ''
      }`}
    >
      <PhoneInput
        country={field.model.defaultCountry}
        onlyCountries={field.model.availableCountries}
        preserveOrder={['preferredCountries']}
        preferredCountries={field.model.prioritizedCountries}
        localization={field.model.localizations}
        placeholder={placeholder}
        value={props.value}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        enableSearch={true}
        disableSearchIcon={true}
        searchPlaceholder={t('cnhi-countrySearch')}
        containerClass="telephone-field__container"
        inputClass="telephone-field__input"
        buttonClass="telephone-field__button"
        dropdownClass="telephone-field__dropdown"
        searchClass="telephone-field__search"
        inputProps={{
          "aria-label": field.model.title,
        }}
      />
      {FieldValidationErrors && <FieldValidationErrors {...props} />}
    </div>
  );
};

export default TelephoneField;
